export default __webpack_public_path__ + "static/article-travel-unusual-destination-d3e343da35ec2c178991116bce5b6f1c.jpg";